import {observer} from "mobx-react";
import {FieldAutoComplete, SelectOption} from "../../../ui";
import {registrationStore} from "../../../../store";
import {OrganizationDto} from "../../../../api";

function map(o: OrganizationDto): SelectOption<any> {
    return {
        label: `${o.name}`,
        value: o
    }
}

const OrganizationPanel = observer(function OrganizationPanel() {
    return <nav className="panel">
        <p className="panel-heading">Standort</p>
        <div className="panel-block">
            <FieldAutoComplete
                required={true}
                disabled={registrationStore.isReadonly}
                onChange={v => {
                    registrationStore.organization = v
                }}
                help={registrationStore.organizationInformation}
                invalid={registrationStore.organizationInvalid}
                onBlur={() => registrationStore.validate()}
                options={registrationStore.allOrganizations.map(map)}
                itemRenderer={v => v.label}
                value={registrationStore.organization as SelectOption<any>}
                search={async v => {
                    return await registrationStore.searchOrganization(v)
                }}
                />
        </div>
    </nav>
})

export {
    OrganizationPanel
}
